import { createAction } from '@reduxjs/toolkit';

import { getFailurePayloadCreator, getPayloadCreator, type Meta } from '../core/actionHelpers';
import type { QcsSyncResourcesPayload } from '../core/resourceStoreTypes';
import type { AccountsBalance, AccountsBalanceProps } from './accountsBalancesTypes';

const failurePayloadCreator = getFailurePayloadCreator<unknown, Meta<AccountsBalanceProps>>();

export const getAccountsBalances = createAction(
  'GET_ACCOUNTS_BALANCES',
  getPayloadCreator<void, AccountsBalanceProps>(),
);
export const getAccountsBalancesSuccess = createAction(
  'GET_ACCOUNTS_BALANCES_SUCCESS',
  getPayloadCreator<QcsSyncResourcesPayload<AccountsBalanceProps>, AccountsBalanceProps>(),
);
export const getAccountsBalancesFailure = createAction('GET_ACCOUNTS_BALANCES_FAILURE', failurePayloadCreator);

export const batchAccountsBalances = createAction(
  'BATCH_ACCOUNTS_BALANCES',
  getPayloadCreator<AccountsBalance[], AccountsBalanceProps>(),
);
export const batchAccountsBalancesSuccess = createAction(
  'BATCH_ACCOUNTS_BALANCES_SUCCESS',
  getPayloadCreator<AccountsBalance[], AccountsBalanceProps>(),
);
export const batchAccountsBalancesFailure = createAction('BATCH_ACCOUNTS_BALANCES_FAILURE', failurePayloadCreator);
